// extracted by mini-css-extract-plugin
var _1 = "_modal-module__body";
var _2 = "_modal-module__close-button";
var _3 = "_modal-module__container";
var _4 = "_modal-module__container-with-timer";
var _5 = "_modal-module__content";
var _6 = "_modal-module__header";
var _7 = "_modal-module__title";
export { _1 as "body", _2 as "close-button", _3 as "container", _4 as "container-with-timer", _5 as "content", _6 as "header", _7 as "title" }
